import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createAutoTailoringUrlParams, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { APP_BASE_PATH, FetchStatuses } from 'builder/modules/constants'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { selectors as userSelectors } from 'builder/modules/user'

export const useTailoredResumeEdit = () => {
  const currentResume = useTypedSelector(selectors.resume)
  const originalResume = useTypedSelector(selectors.originalResume)
  const approveAutoTailoredResumeStatus = useTypedSelector(
    selectors.approveAutoTailoredResumeStatus,
  )
  const {
    averageScore: newScore,
    recommendedJobTitle,
    employerName,
  } = useTypedSelector(selectors.jobPostingAPIData)
  const oldScore = currentResume?.originalResumeAvgScore || 0
  const [isEditActive, setIsEditActive] = useState(false)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const isApproving = approveAutoTailoredResumeStatus === FetchStatuses.loading
  const { mode, jobCardId, jobPostingId } = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )
  const user = useTypedSelector(userSelectors.userData)
  const navigate = useNavigate()
  const toggleEditContainer = useCallback(() => {
    setIsEditActive(!isEditActive)
  }, [isEditActive])

  const getJobTrackingPath = useCallback(() => {
    const successSearchParams = createAutoTailoringUrlParams({
      mode,
      jobCardId: currentResume?.jobCardId || jobCardId,
      showResumeTailoredBanner: true,
    })

    return `/job-tracking?${successSearchParams.toString()}`
  }, [jobCardId, mode, currentResume?.jobCardId])

  const handleRedirect = useCallback(() => {
    if (user?.hasPremiumFeatures) {
      navigate(getJobTrackingPath())
      return
    }

    const closeSearchParams = createAutoTailoringUrlParams({
      mode,
      showSelfTailorModal: true,
      resumeId: currentResume?.id,
      jobPostingId: currentResume?.jobPostingId || jobPostingId,
      jobCardId: currentResume?.jobCardId || jobCardId,
      preventUrlParamsCleanup: true,
      showResumeTailoredBanner: true,
    })

    goToBillingPlanPage({
      onSuccessRedirect: `${APP_BASE_PATH}${getJobTrackingPath()}`,
      onCloseRedirect: `${APP_BASE_PATH}/job-tracking?${closeSearchParams.toString()}`,
    })
  }, [
    navigate,
    currentResume,
    getJobTrackingPath,
    mode,
    user?.hasPremiumFeatures,
    jobCardId,
    jobPostingId,
  ])

  return {
    oldScore,
    newScore,
    tailoredDesignation,
    toggleEditContainer,
    isEditActive,
    currentResume,
    originalResume,
    isApproving,
    handleRedirect,
    getJobTrackingPath,
    setIsEditActive,
  }
}
